import { render, staticRenderFns } from "./TableStatsNavigation.vue?vue&type=template&id=b5134ba0"
import script from "./TableStatsNavigation.vue?vue&type=script&lang=js"
export * from "./TableStatsNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports